<template>
  <div class="wrap">
    <div class="syj_Betinfo-shadow"></div>
    <div class="syj_Betinfo" :class="{ 'edit-mode': editFlag }">
      <div class="betClose">
        <img
            @click="IsClosebet"
            src="../assets/images/betClose.png"
        />
      </div>
      <div class="syj_Betinfo-tab" v-if="!editFlag">
        <div
            class="tabbet"
            :class="tab.value === activeTab ? 'actived' : ''"
            v-for="tab in tabs"
            :key="tab.value"
            @click="onTab(tab)"
        >
          <label>
            <span/>
          </label>
          <span class="label">{{ tab.label }}</span>
        </div>
      </div>

      <div
          class="syj_betcontentinput tab-content_0"
          :class="activeTab === 0 ? 'actived' : ''"
      >
        <div class="tab-content_0_group">
          <div
              class="syj_betting_group"
              v-if="!this.editFlag"
          >
            投注数量
            <label
                class="label"
                v-for="(item) in bettingGroup"
                :key="item"
                @click="tab0_groupChange(item)"
            >
              <input
                  type="radio"
                  name="group"
                  :key="item"
                  v-model="lotteryInfo.line"
                  :value="item"
              /><span></span>{{ item }}注
            </label>
            <label
                class="label"
                @click="tab0_groupChange('自定义')"
            >
              <input
                  type="radio"
                  name="group"
                  value="自定义"
              /><span></span>
              <div v-if="!tabs[0].isCustom">自定义</div>
              <div class="input-wrap" v-else>
                <input
                    type="text"
                    v-model="tabs[0].line"
                />
                <div class="btn" @click.stop="e => onSaveLine(e, 0)">确定</div>
              </div>
              
            </label>
          </div>
        </div>

        <div class="tab-content_0_num" v-if="this.numInfo.length > 0">
          <div
              class="syj_betnum"
              :class="[
                  `bet-id_${index}`
              ]"
              v-for="(item, index) in lotteryInfo.line"
              :key="index"
          >
            <label>第{{ index + 1 }}注</label>
            <div class="syj_betnum-input">
              <span
                  v-for="(site, key) in lotteryInfo.num"
                  :key="key"
              >
                <input
                    class="lottery_input"
                    :class="[
                      `border-input_${index}`,
                      `lottery_${handleSerialId(index, key)}`,
                    ]"
                    :name="`number[${index}][name]`"
                    :key="`n_${index}_${key}`"
                    type="text"
                    v-model="numInfo[index][key]"
                    :data-id="handleSerialId(index, key)"
                    autocomplete="off"
                    @input="inputBetnum($event, index, key)"
                    @keyup="nextFocus($event, index, key)"
                    @mouseup="onBlur"
                    @paste="handleBatchInput($event, index, key)"
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
          class="syj_betcontentinput tab-content_1"
          :class="activeTab === 1 ? 'actived' : ''"
      >
        <div class="syj_sky">
          <label
              v-for="item in randomTabs"
              :key="item.value"
              :class="item.value === randomTab ? 'actived' : ''"
              @click="onRandomTab(item)"
          >
            {{ item.label }}
          </label>
        </div>

        <div
            class="syj_betting_group"
            v-if="!this.editFlag"
        >
          投注数量
          <label
              class="label"
              v-for="(item,index) in bettingGroup"
              :key="index"
              @click="bettingGroupChange(item)"
          >

            <input
                type="radio"
                name="betting_group"
                :key="index"
                v-model="radioVal"
                :value="item"
            /><span></span>{{ item }}注
          </label>
          
          <label
              class="label"
              @click="bettingGroupChange('自定义')"
          >
            <input
                type="radio"
                name="betting_group"
                v-model="radioVal"
                value="自定义"
            /><span></span>
            <div v-if="!tabs[1].isCustom">自定义</div>
            <div class="input-wrap" v-else>
              <input
                  type="text"
                  v-model="tabs[1].line"
              />
              <div class="btn" @click.stop="e => onSaveLine(e, 1)">确定</div>
            </div>
          
          </label>
        </div>
        
        <div
            class="sky-input price-wrap"
        >
          <div class="tz_title">投注金额</div> <i class="line"></i>
          <input
              class="tz_input"
              type="number"
              v-model="priceValue"
              placeholder="按金额生成投注数量"
              @focus="focusPrice"
              @wheel.prevent
          />
          <div
              class="btn"
              v-if="randomTab === 0"
              @click="onPriceBtn"
          >生成
          </div>
        </div>

        <div
            class="sky-input"
            v-if="qujianCLose"
        >
          <input
              class="section-input"
              type="number"
              placeholder="区间最小值"
              v-model="strNum"
          /> <i>-</i>
          <input
              class="section-input"
              type="number"
              placeholder="区间最大值"
              v-model="endNum"
          />
          <div
              class="btn"
              @click="handelRodmonSave"
          >生成
          </div>
        </div>
        <div class="sky">
          <div
              v-for="(item, index) in BetListInputrandom"
              :key="index"
              class="syj_betnum"
              :class="[
                  `bet-id_${index}`
              ]"
          >
            <div class="syj_betnum-input">
							<span
                  class="numrandom"
                  v-for="(item2, index2) in item"
                  :key="index2"
              >
								<input
                    :name="`number[${index}][name]`"
                    :key="index2"
                    type="text"
                    v-model="item[index2]"
                    @input="inputBetnumRodmon($event, index, index2)"
                />
							</span>
            </div>
            <div
                class="cursorPointer delete"
                @click="del(index)"
            >x
            </div>
          </div>
        </div>
      </div>

      <div class="notice">
        <div style="font-size: 12px;text-align: center;">合理竞猜，财路打开！一注包赢，多注躺平！</div>
        <div style="font-size: 12px;margin-top: 10px;text-align: center;">竞猜时间段:
          {{ $_parent.currentActivityInfo.activity_round.ing_start_time }} ~
          {{ $_parent.currentActivityInfo.activity_round.ing_end_time }}
        </div>
      </div>
      <!--      <div class="notice">测试轮5元一注，买一赠九，每人限购一次</div>-->
      <!-- 投注 弹出层相关内容 end -->
      <!-- selectBox 下单承诺 start -->
      <div class="syj_contentselect">
        下单承诺
        <div
            class="selectBox"
            style="width: 278px"
        >
          <div
              class="selectBox_show"
              v-on:click.stop="selectarrowDown"
          >
            <p>{{ unitName }}</p>
            <i></i>
          </div>
          <div
              class="selectBox_list"
              v-show="isShowSelect"
          >
            <div
                class="selectBox_listLi"
                v-for="(item, index) in selectdataList"
                :key="index"
                @click="select(item, index)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <!-- selectBox 下单承诺 end -->
      <div
          class="btnselect"
          @click="addToBetList"
      >
        确认下注
      </div>
    </div>
    <PayQrCode-info @IsClosebetp="IsClosebet" @IsCloseqrcodelist="IsCloseQrcode" v-if="onOpenQrcode"
                    :parentQrcodeData="QrcodeData"></PayQrCode-info>
    <div v-if="paymentisLoading" class="bill_loading">
      <div class="bill_loading-spinner"></div>
    </div>
  </div>
</template>
<script>
import maiyuanRequest from "../units/maiyaunRuquest.js";
import {memberBetting, editOrder, creat_qrcode, memberPrice_per_bet} from "../units/api.js";
import {getActivity} from "../units/activity.js";
import PayQrCode from "@/components/PayQrCode";

export default {
  name: "",
  inject: ['$_parent'],
  data() {
    return {
      paymentisLoading: false,//支付请求加载动画
      qujianCLose: false,
      // Betnum: 1,
      // BetListInput: [], //投注list
      // BetListInputline: [], //投注行数
      // Betnumandom: 1,
      // BetListNum: "第",
      // BetListNumend: "注",
      QrcodeData: {},//付款码数据
      unitName: "假如我中奖了......",
      isShowSelect: false,
      selectdataList: [], //suijish
      BetListInputrandom: [],
      BetListInputtext: [],
      activeTab: 0,
      tabs: [{
        label: "我命由我",
        value: 0,
        line: '',
        isCustom: false,
      }, {
        label: "我命由天",
        value: 1,
        line: '',
        isCustom: false,
      }],
      randomTab: 0,
      randomTabs: [{
        label: "全都由天",
        value: 0
      }, {
        label: "给个区间",
        value: 1
      }],
      strNum: null,
      endNum: null,
      numInfo: [],
      lotteryInfo: {
        line: 10, // 行数
        num: 7,   // 位数
      },
      lotterySubmitType: true, //区分投注类型
      lotteryEditType: false, //是否修改类型
      unitId: null, //下单承诺ID,
      bettingGroup: [10, 20, 100],
      radioVal: 10,
      onOpenQrcode: this.onOpenQrcode,//支付弹窗开关
      priceValue: '',
    };
  },
  props: ["parentBetListInputline", "orderId", "editFlag"],
  mounted() {
    // //行数初始化
    // for (let i = 1; i <= 10; i++) {
    //   this.BetListInputline.push(
    //       this.BetListNum + "" + i.toString() + "" + this.BetListNumend
    //   );
    // }
    this.homeOderprimose();
    //是否父类传值
    if (this.editFlag === true && this.parentBetListInputline) {
      this.lotteryEditType = true; //设置为修改类型
      // this.numInfo = this.parentBetListInputline;
      // console.log('this.numInfo', this.numInfo)
      //
      // let sheng = this.lotteryInfo.line - this.numInfo.length;
      // if (sheng > 0) {
      //   let num = new Array(sheng);
      //   for (let i = 0; i < num.length; i++) {
      //     num[i] = new Array(this.lotteryInfo.num);
      //   }
      //   this.numInfo = this.numInfo.concat(num);
      // }
      this.betsInit(this.parentBetListInputline)
    } else {
      this.lotteryInit();
    }
    if (!this.lotteryEditType) {
      this.onTab({value: 1})
      // this.tab2();//默认我命由天
    } else {
      // 修改模式下，默认显示"我命由我"
      this.activeTab = 0;
      this.lotterySubmitType = true;
    }
    // this.homeBetPop();
  },
  components: {
    "PayQrCode-info": PayQrCode,
  },
  methods: {
    betsInit (list) {
      this.lotteryInfo.line =
          this.bettingGroup.find((value) => list.length <= value) ||
          this.bettingGroup[this.bettingGroup.length - 1];
      this.lotteryInit();
      this.numInfo = [...list, ...this.numInfo]
    },
    IsCloseQrcode() {
      this.onOpenQrcode = false;
    },
    inputBetnumRodmon(event, index, key) {
      this.BetListInputrandom[index][key] = event.currentTarget.value.match(/\d{1}?/)
          ? parseInt(event.currentTarget.value.match(/\d{1}?/)[0])
          : null;
    },

    async tab0_groupChange(item) {
      if (item === '自定义') {
        this.tabs[0].isCustom = true
        return
      }
      this.tabs[0].isCustom = false
      this.lotteryInfo.line = item
      this.lotteryInit()
    },

    async bettingGroupChange(item) {
      if (item === '自定义') {
        this.tabs[1].isCustom = true
        return
      }
      this.tabs[1].isCustom = false
      this.radioVal = item
      let settingGroupStrNum = ''
      let settingGroupEndNum = ''
      if (this.randomTab !== 0) {
        settingGroupStrNum = this.strNum ? this.strNum : ''
        settingGroupEndNum = this.endNum ? this.endNum : ''
      }
      console.log('settingGroupStrNum', settingGroupStrNum, settingGroupEndNum, item)
      await this.getRandomNumber(settingGroupStrNum, settingGroupEndNum, item).then((res) => {
        let response = res.data;
        
        const list = this.handleRandomNumberSort(response.data)
        this.BetListInputrandom = [];
        
        for (let i = 0; i < list.length; i++) {
          this.BetListInputrandom[i] = list[i];
        }
        this.BetListInputrandom = JSON.parse(JSON.stringify(this.BetListInputrandom))
      });
    },
    
    handleRandomNumberSort(list) {
      const arr = JSON.parse(JSON.stringify(list))
      arr.sort((a, b) => {
        // 比较前6位
        for (let i = 0; i < 6; i++) {
          if (a[i] !== b[i]) {
            return a[i] - b[i];
          }
        }
        // 如果前6位相同，比较第7位（最后一位）
        return a[6] - b[6];
      });
      
      return arr;
    },

    validateBet(list) {
      try {
        const validList = []
        const failedList = []
        
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          const n = item.join('')
          
          if (n.length > 0) {
            if (n.length < 7) {
              failedList.push({
                data: item,
                index: i,
              })
            } else if (isNaN(Number(n))) {
              failedList.push({
                data: item,
                index: i,
              })
            } else {
              validList.push(item)
            }
          }
        }
        if (failedList.length > 0) {
          let scrollContainer = null
          if (this.activeTab === 0) {
            scrollContainer = document.querySelector(`.tab-content_0 .tab-content_0_num`)
          } else {
            scrollContainer = document.querySelector(`.tab-content_1 .sky`)
          }

          const target = scrollContainer.querySelector(`.bet-id_${failedList[0].index}`);
          target.scrollIntoView({ behavior: 'auto', block: 'start' });
          
          const failedText = failedList.map(item => `第 ${item.index + 1} 注`).join('、');
          
          let msg = `投注错误: ${failedText}`
          
          if (validList.length === 0 && failedList.length === 100) {
            msg = '投注错误: 你无敌了！'
          }
          
          this.$alert(msg, "", "", {
            customClass: "customTotasClass",
            customContainerClass: "containerClass",
          });
          
          return false
        }
        
        return validList;
      } catch (e) {
        console.log('err', e, e.message)
      }

    },

    ValidityOrder(num) {
      console.log("num", num);
      let flag = [];
      for (let i = 0; i < num.length; i++) {
        flag[i] = 0;
        for (let j = 0; j < num[i].length; j++) {
          if (num[i][j] != null) {
            flag[i]++;
          }
        }
      }
      console.log("num", flag);
      for (let k = 0; k < flag.length; k++) {
        if (flag[k] > 0 && flag[k] < 7) {
          return false;
        }
      }
      let nums = 0;
      for (let k = 0; k < flag.length; k++) {
        if (flag[k] > 0 && flag[k] == 7) {
          nums++;
        }
      }
      return nums;
    },
    del(index) {
      this.BetListInputrandom.splice(index, 1);
    },

    lotteryInit() {
      this.numInfo = Array.from({length: this.lotteryInfo.line}).map(() => {
        return new Array(this.lotteryInfo.num).fill(null)
      });
      // this.numInfo = Array.from({length: this.lotteryInfo.line}).map(() => {
      //   return new Array(this.lotteryInfo.num).fill(null)
      // });
    },

    IsClosebet() {
      this.$emit("IsClosebetlist");
    },
    selectarrowDown() {
      this.isShowSelect = !this.isShowSelect;
      // this.selectdataList.push({
      //   selectdataList: this.selectdataList,
      // });
    },
    select(item) {
      this.isShowSelect = false;
      this.unitId = item.id;
      this.unitName = item.title;
    },
    addToBetList() {
      // this.BetListInput.push(this.Betnum);
      // this.BetListInput.push(this.Betnumandom);

      this.homeBetPop();
      // console.log(this.BetListInput, this.lotterySubmitType);
    },
    onBlur(e) {
      if (e.target.value.length > 0) {
        e.target.select();
      }
    },

    inputBetnum(event, index, key) {
      this.numInfo[index][key] = event.currentTarget.value.match(/\d{1}?/)
          ? parseInt(event.currentTarget.value.match(/\d{1}?/)[0])
          : null;

      // this.Betnum = event.currentTarget.value;
      // this.site = event.currentTarget.value;
    },

    handleBatchInput(event, index) {
      const pasteData = event.clipboardData.getData("text");

      try {
        const reg = /^(?:\d{1,7}(?:[ \n\r]+)?)*\d{1,7}$/
        if (reg.test(pasteData) && pasteData.length > 1) {
          let list = pasteData.split(/\s+/)

          const remainingSpace = this.numInfo.length - index;
          if (list.length > remainingSpace) {
            list = list.slice(0, remainingSpace)
          }
          list = list.map(item => {
            return item.split('').map(i => Number(i))
          })
          this.$nextTick(() => {
            this.numInfo.splice(index, list.length, ...list);
          })
        }
      } catch (e) {
        console.log(e, 'err')
      }
    },

    handleSerialId(row_idx, col_idx) {
      return row_idx * this.lotteryInfo.num + col_idx;
    },

    nextFocus(e) {
      const id = Number(e.target.dataset.id);
      const nextEl = document.querySelector(`.lottery_input[data-id="${id + 1}"]`)
      const lastEl = document.querySelector(`.lottery_input[data-id="${id - 1}"]`)

      if (e.target.value === '' && ['Delete', 'Backspace'].includes(e.key)) {
        lastEl?.focus();
        lastEl?.select();
        return
      }
      if (e.target.value !== '') {
        if ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode >= 96 && e.keyCode <= 105) {
          nextEl?.focus();
          nextEl?.select();
        }
      }
    },

    inputStr(event) {
      this.strNum = event.currentTarget.value;
      console.log("strNum", this.strNum);
    },
    inputEnd(event) {
      this.endNum = event.currentTarget.value;
    },
    async onTab(tab) {
      this.activeTab = tab.value;

      if (tab.value === 0) {
        this.lotterySubmitType = true;
      } else {
        const res = await this.getRandomNumber()

        const response = res.data;
        const list = this.handleRandomNumberSort(response.data)
        this.BetListInputrandom = []
        this.$nextTick(() => {
          this.BetListInputrandom = JSON.parse(JSON.stringify(list))
        })

        this.lotterySubmitType = false;
      }
    },
    
    focusPrice(e) {
      console.log(e)
      this.radioVal = null
      this.tabs[0].isCustom = false
      this.tabs[1].isCustom = false
      this.tabs[0].line = ''
      this.tabs[1].line = ''
    },
    async onPriceBtn() {
      if (Number(this.priceValue) < 5 || Number(this.priceValue) > 1000) {
        this.$alert('请输入投注金额5至1000元', "", "", {
          customClass: "customTotasClass",
          customContainerClass: "containerClass",
        });
        return
      }
      try {
        const activityInfo = getActivity()
            ? JSON.parse(getActivity())
            : null;
        const activtiyId = activityInfo.activityId || null;
        const activityRoundId = activityInfo.activityRoundId || null;
        let settingGroupStrNum = ''
        let settingGroupEndNum = ''
        if (this.randomTab !== 0) {
          settingGroupStrNum = this.strNum ? JSON.parse(JSON.stringify(this.strNum)): ''
          settingGroupEndNum = this.endNum ? JSON.parse(JSON.stringify(this.endNum)) : ''
        }
        let section
        if (settingGroupStrNum !== '' && settingGroupEndNum !== '') {
          section = `${settingGroupStrNum}--${settingGroupEndNum}`
        }
        const res = await memberPrice_per_bet({
          activtiy_id: activtiyId,
          activity_round_id: activityRoundId,
          amount: this.priceValue,
          section: section || ''
        })
        if (res.status !== 200 || res.data.status !== 200) {
          throw new Error(res.data.message)
        }
        const msg = `已为您生成${res.data.data.totalBets}注！成功下注后，实际需支付${res.data.data.amountToPay}元～`
        
        this.$alert(msg, "", "", {
          customClass: "customTotasClass",
          customContainerClass: "containerClass",
        });
        console.log('===', res)
        const list = this.handleRandomNumberSort(res.data.data.betsList)
        this.BetListInputrandom = [];
        for (let i = 0; i < list.length; i++) {
          this.BetListInputrandom[i] = list[i];
        }
        this.BetListInputrandom = JSON.parse(JSON.stringify(this.BetListInputrandom))
      } catch (e) {
        console.log(e)
      }
    },

    async onRandomTab(tab) {
      if (tab.value === 0) {
        this.radioVal = 10
        let settingNum = this.radioVal
        const res = await this.getRandomNumber('', '', settingNum)
        const response = res.data;
        const list = this.handleRandomNumberSort(response.data)
        this.BetListInputrandom = []
        this.$nextTick(() => {
          this.BetListInputrandom = JSON.parse(JSON.stringify(list))
        })
        this.qujianCLose = false;
      } else {
        this.radioVal = 10
        let settingNum = this.radioVal
        const res = await this.getRandomNumber('', '', settingNum)
        const response = res.data;
        const list = this.handleRandomNumberSort(response.data)
        this.BetListInputrandom = []
        this.$nextTick(() => {
          this.BetListInputrandom = JSON.parse(JSON.stringify(list))
        })
        this.qujianCLose = true;
      }

      this.randomTab = tab.value;
    },
    async handelRodmonSave() {
      console.log('this.priceValue', this.priceValue)
      if (this.priceValue !== '') {
        this.onPriceBtn()
      } else if (this.priceValue === '') {
        this.qujianrodmon()
      }
    },
    async qujianrodmon() {
      // console.log(this.strNum,this.endNum)
      // let that = this;
      // let strNum = that.strNum ? that.strNum : 59999;
      // let endNum = that.endNum ? that.endNum : 130000;
      // //  this.make(strNum,endNum);
      // if (strNum >= 59999 && endNum <= 130000) {
      //   return;
      // } else {
      //   that.$toast.show("区间值最少59999最大值130000");
      // }
      
      // 处理自定义注数的情况
      let settingNum = this.radioVal;
      if (this.radioVal === '自定义') {
        if (!this.tabs[1].line || this.tabs[1].line === '') {
          this.$alert('请输入自定义投注数量', "", "", {
            customClass: "customTotasClass",
            customContainerClass: "containerClass",
          });
          return;
        }
        const regex = /^(?:[1-9]|[1-9][0-9]|1[0-9]{2}|200)$/;
        if (!regex.test(this.tabs[1].line)) {
          this.$alert("请输入1-200以内的数字", "", "", {
            customClass: "customTotasClass",
            customContainerClass: "containerClass",
          });
          return;
        }
        settingNum = Number(this.tabs[1].line);
      } else if (!this.radioVal) {
        this.$alert('请选择投注数量', "", "", {
          customClass: "customTotasClass",
          customContainerClass: "containerClass",
        });
        return;
      }
      
      await this.getRandomNumber(this.strNum, this.endNum, settingNum).then((res) => {
        let response = res.data;
        if (response.status == 400) {
          this.$alert(response.msg, "", "", {
            customClass: "customTotasClass",
            customContainerClass: "containerClass",
          });
          return;
        }
        const list = this.handleRandomNumberSort(response.data)
        this.BetListInputrandom = [];
        for (let i = 0; i < response.data.length; i++) {
          this.BetListInputrandom[i] = list[i];
        }
        this.BetListInputrandom = JSON.parse(JSON.stringify(list))
      });
      // that.lotterySubmitType = false;
    },
    getRandomNumber(strNum, endNum, num = 10) {
      let params = {digit: 6, num}
      if (strNum && endNum) {
        params = {digit: 6, section: strNum + "--" + endNum, num}
      }
      return new Promise((resolve, reject) => {
        maiyuanRequest({
          method: "get",
          url: "random_number", //下单承诺的接口
          params,
        })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
      });
    },
    make(num1, num2) {
      let that = this;
      let s = this.lotteryInfo.line; //生成的数组数量
      this.BetListInputrandom = [];
      for (let i = 0; i < s; i++) {
        this.BetListInputrandom[i] = that.shengcheng(num1, num2);
      }
    },
    shengcheng(num1 = 59999, num2 = 130000) {
      console.log(typeof num2, typeof num1);
      // console.log(Math.floor((num2-num1)*Math.random()+num1)+"," + Math.floor(Math.random() * 10) + "")
      let num =
          Math.floor(
              (parseInt(num2) - parseInt(num1)) * Math.random() + parseInt(num1)
          ) +
          "" +
          Math.floor(Math.random() * 10);
      console.log("jennynum", num);
      return this.prefixZero(num, 7).split("");
    },
    prefixZero(num, n) {
      return (Array(n).join(0) + num).slice(-n);
    },
    
    homeBetPop() {
      const that = this;
      let betList = null;
      const type = this.lotterySubmitType ? 1 : 2;
      const promiseId = this.unitId ? this.unitId : null;
      if (this.lotterySubmitType) {
        betList = this.numInfo;
      } else {
        betList = this.BetListInputrandom;
      }

      // 验证
      const validateBetList = this.validateBet(betList);

      if (!validateBetList) {
        return
      }
      
      if (validateBetList.length === 0) {
        this.$alert("一注包赢，多注躺平！请下注！", "", "", {
          customClass: "customTotasClass",
          customContainerClass: "containerClass",
        });
        
        return
      }

      if (promiseId == null) {
        this.$toast.show("至少选择一个下单承诺", 10000);
        return true;
      }

      this.$confirm("确认下注数量为" + validateBetList.length + "注?", "", "", {
        customContainerClass: "containerClass",
        cancelButtonText: "再想想", confirmButtonText: "OK",
        showLoaderOnConfirm: true,
        preConfirm: function () { //功能执行前确认操作，支持function
          let jiangjinchi = new Promise(function (resolve) {
            if (that.lotteryEditType === true) {
              let params = {order_id: that.orderId};
              let data = {type: type, promise_id: promiseId, num: validateBetList};
              that.paymentisLoading = true;
              editOrder(params, data).then((res) => {
                that.paymentisLoading = false;
                let response = res.data;
                that.IsClosebet();
                that.$emit("editData", that.orderId, validateBetList);
                that.$toast.show(response.msg, 10000);
                console.log("请立即打印奖券去");
                resolve()
              });
            } else {
              let activityInfo = getActivity()
                  ? JSON.parse(getActivity())
                  : null;
              let activtiyId = activityInfo.activityId || null;
              let activityRoundId = activityInfo.activityRoundId || null;
              that.paymentisLoading = true;
              memberBetting(
                  {type: type, promise_id: promiseId, num: validateBetList},
                  {activtiy_id: activtiyId, activity_round_id: activityRoundId}
              ).then((res) => {
                if (res.status == 400) {
                  that.paymentisLoading = false;
                  that.$toast.show(res.msg, 10000);
                  resolve()
                  // return;
                } else {
                  let response = res.data;
                  that.payment(response.data.order_ids)
                  // that.$toast.show(response.msg, 10000);
                  resolve()
                }
              });
            }
          })
          console.log("aaaa", jiangjinchi)
        },
        allowOutsideClick: () => !this.IsClosebet()
      }).then((result) => {
        console.log(result)
      }).catch(error => {
        console.log('error2', error)
      });
    },

    payment: function (selectedValues) {  //投注成功后直接弹付款
      if (selectedValues.length == 0) {
        this.$toast.show('订单信息错误', 10000);
      } else {
        let order_ids = selectedValues.join(',');
        let activityInfo = getActivity()
            ? JSON.parse(getActivity())
            : null;
        let activtiyId = activityInfo.activityId || null;
        let activityRoundId = activityInfo.activityRoundId || null;
        creat_qrcode(
            {activtiy_id: activtiyId, activity_round_id: activityRoundId, order_id: order_ids}
        ).then((res) => {
          this.paymentisLoading = false;
          if (res.status == 400) {
            this.$toast.show(res.msg, 10000);
            return;
          } else {
            this.QrcodeData = res.data
            this.onOpenQrcode = true
            // this.IsClosebet();
            console.log(this.QrcodeData)
          }
        });
      }
    },
    homeOderprimose() {
      maiyuanRequest({
        method: "get",
        url: "order_promise", //下单承诺的接口
      }).then((res) => {
        let response = res.data;
        this.selectdataList = response.data;
      });
    },
    
    async onSaveLine(e, type) {
      e.preventDefault();
      if (type === 0) {
        try {
          if (this.tabs[0].line === '') {
            this.$alert("请输入1-200以内的数字", "", "", {
              customClass: "customTotasClass",
              customContainerClass: "containerClass",
            });
            return;
          }
          const regex = /^(?:[1-9]|[1-9][0-9]|1[0-9]{2}|200)$/;
          if (!regex.test(this.tabs[0].line)) {
            this.$alert("请输入1-200以内的数字", "", "", {
              customClass: "customTotasClass",
              customContainerClass: "containerClass",
            });
            return;
          }
          this.lotteryInfo.line = Number(this.tabs[0].line);
          this.lotteryInit()
        } catch (e) {
          this.$alert("请输入1-200以内的数字", "", "", {
            customClass: "customTotasClass",
            customContainerClass: "containerClass",
          });
        }
      } else {
        try {
          if (this.tabs[1].line === '') {
            this.$alert("请输入1-200以内的数字", "", "", {
              customClass: "customTotasClass",
              customContainerClass: "containerClass",
            });
            return;
          }
          const regex = /^(?:[1-9]|[1-9][0-9]|1[0-9]{2}|200)$/;
          if (!regex.test(this.tabs[1].line)) {
            this.$alert("请输入1-200以内的数字", "", "", {
              customClass: "customTotasClass",
              customContainerClass: "containerClass",
            });
            return;
          }
          let num = Number(this.tabs[1].line)
          let settingGroupStrNum = this.strNum ? this.strNum : ''
          let settingGroupEndNum = this.endNum ? this.endNum : ''
          console.log('settingGroupStrNum', settingGroupStrNum, settingGroupEndNum,num)
          await this.getRandomNumber(settingGroupStrNum, settingGroupEndNum, num).then((res) => {
            let response = res.data;
            console.log('response', response)
            if (response.status != 200) {
              throw new Error(response.msg)
            }
            const list = this.handleRandomNumberSort(response.data)
            this.BetListInputrandom = [];
            for (let i = 0; i < list.length; i++) {
              this.BetListInputrandom[i] = list[i];
            }
            this.BetListInputrandom = JSON.parse(JSON.stringify(this.BetListInputrandom))
          });
        } catch (e) {
          console.log('err', e)
          this.$alert(e.message, "", "", {
            customClass: "customTotasClass",
            customContainerClass: "containerClass",
          });
        }
      }
    }
  },
};
</script>

<style lang="less">
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.syj_betting_group {
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0px 0 12px;

  label {
    position: relative;
    cursor: pointer;
  }

  label span {
    width: 10px;
    height: 10px;
    border: 2px solid #e81f3c;
    display: inline-block;
    border-radius: 50%;
    margin: 0 2px 0 4px;
  }

  label input[type="radio"] {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }
}

.syj_betting_group label input:checked ~ span:after {
  content: "";
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  background: #e81f3c;
  border-radius: 100%;
  left: 4px;
  top: 4px;
  transform: scale(0.45);
}

.syj_Betinfo {
  .notice {
    color: #fff;
    text-align: left;
    width: 73%;
    margin-top: 12px;
    line-height: 12px;
    font-size: 14px;
  }

  .icon-jiao {
    position: relative;
    width: 20px;
    height: 20px;
    display: inline-block;

    &::after {
      position: absolute;
      width: 8px;
      height: 1px;
      content: "";
      background: #ffffff;
      left: 10px;
      bottom: 6px;
      z-index: 1;
      transform: rotate(-45deg);
    }

    &::before {
      position: absolute;
      width: 8px;
      height: 1px;
      content: "";
      background: #ffffff;
      left: 10px;
      top: 8px;
      z-index: 1;
      transform: rotate(45deg);
    }
  }

  .syj_contentselect {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 73%;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 1px;
    margin-top: 12px;

    .selectBox {
      border: 2px solid #fb3123;
      background: #fff;

      .selectBox_show {
        text-align: left;
        cursor: pointer;
        position: relative;

        p {
          color: red;
          font-size: 12px;
          padding: 10px 0;
          padding-left: 10px;
          margin: 0;
        }

        i {
          position: absolute;
          top: 15px;
          right: 10px;
          width: 0;
          height: 0;
          border-width: 8px 6px 0;
          border-style: solid;
          border-color: #fb3123 transparent;
          border-radius: 10px;
          display: inline-block;
        }
      }
    }

    .selectBox_list {
      height: 120px;
      color: #2e2e2e;
      margin-bottom: 5px;
      text-align: left;
      overflow: auto;
      font-size: 12px;
      padding-left: 10px;
      line-height: 22px;
      background-color: #ffffff;
      position: absolute;
      width: 268px;
      border: 2px solid #f44336;
      margin-left: -2px;
      border-top: none;

      .selectBox_listLi {
        cursor: pointer;
      }

      .selectBox_listLi:hover {
        color: #f44336;
      }
    }
  }

  .betClose {
    width: auto;
    cursor: pointer;
    text-align: right;
    margin: 10px 8px 3px;
    position: absolute;
    top: 0;
    right: 7px;
  }

  .syj_Betinfo-tab {
    width: 370px;
    display: flex;
    justify-content: space-around;
    padding: 5px 0 10px;
    color: #fff;
    margin-top: 40px;

    .tabbet {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      label {
        position: relative;
        width: 16px;
        height: 16px;
        border: 2px solid #e81f3c;
        display: block;
        border-radius: 50%;
        margin-right: 10px;
      }

      &.actived {
        label {
          span {
            width: 10px;
            height: 10px;
            background: #e81f3c;
            display: inline-block;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }

  .syj_Betinfo-tab-edit {
    display: none;
  }

  .sky {
    .delete {
      border: 1px solid #fb3123;
      width: 14px;
      height: 14px;
      display: flex;
      justify-content: center;
      line-height: 11px;
      color: #fb3123;
      margin-left: 5px;
      letter-spacing: -1px;
      font-weight: 600;
    }

    .syj_betnum .syj_betnum-input {
      margin-left: 0;
    }

    display: block;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 350px;
    align-items: flex-start;
    margin: 0 auto 15px;
    background: #fdf4ed;
    padding: 18px 10px;
    min-height: 240px;
    overflow: auto;
    max-height: 255px;

    .syj_betnum {
      margin: 12px 0;
      width: 50%;
      float: left;
      justify-content: center;
    }
  }

  .syj_betnum {
    label {
      width: 70px;
    }

    display: inline-flex;
    color: #fff;
    margin: 4px 0;
    align-items: center;

    .syj_betnum-input {
      margin-left: 10px;
      display: flex;
    }

    span {
      &.numrandom {
        &:last-child {
          &::after {
            left: -15px;
          }

          margin-left: 16px;
        }

        width: 12px;
        height: 26px;
        margin: 0 3px;
        border: none;

        input {
          font-size: 22px;
          width: 12px;
        }
      }

      width: 28px;
      height: 33px;
      border: 2px solid #fb3123;
      display: block;
      margin: 0 5px;
      border-radius: 4px;

      &:last-child {
        margin-left: 29px;
        position: relative;

        &::after {
          position: absolute;
          width: 10px;
          height: 1px;
          background: #f44336;
          content: "";
          left: -22px;
          top: 50%;
        }
      }

      input {
        outline: none;
        text-align: center;
        width: 100%;
        height: 100%;
        padding: 0;
        background: #fff;
        border: none;
        color: #ef0606;
      }
    }
  }

  background: #363fb5;
  position: fixed;
  width: 500px;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 25px;

  .btnselect {
    width: 138px;
    height: 35px;
    color: #fff;
    background: linear-gradient(#fb3123 13%, #fb3123 76%);
    border: none;
    border-radius: 25px;
    cursor: pointer;
    box-shadow: 1px 2px 0px #fb3123;
    line-height: 35px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 1px 3px 4px #770a03;
  }

  .syj_betcontentinput {
    display: none;

    &.actived {
      display: block;
    }
  }

  .syj_Betinfo.edit-mode {
    .syj_betcontentinput {
      margin-top: 60px;
    }
  }

  .syj_sky {
    label {
      background: url(https://maiyuan-zhusun.oss-cn-hangzhou.aliyuncs.com/upload/skytabdefault.png) no-repeat center center;
      width: 170px;
      height: 52px;
      line-height: 52px;
      color: #fff;
      font-weight: 600;
      cursor: pointer;

      &.actived {
        color: #fffc00;
      }
    }

    width: 370px;
    display: flex;
    justify-content: space-between;
    padding: 18px 0 12px;
    margin: auto;
  }

  .sky-input {
    display: flex;
    width: 370px;
    margin: auto;
    align-items: center;
    padding-bottom: 10px;

    input {
      outline: none;
      text-align: center;
      width: 110px;
      height: 36px;
      padding: 0;
      border: 2px solid #ef0606;
      color: #b2b2b2;
      margin-right: 10px;
      padding-left: 10px;
      background: #fff;
    }

    i {
      margin-right: 10px;
    }

    .btn {
      border-radius: 3px;
      background: #fb3123;
      line-height: 36px;
      padding: 0 12px;
      color: #fff;
      width: 78px;
      height: 36px;
      border: 2px solid #fff;
      font-weight: 600;
    }
  }
}

//支付请求loading  start
.bill_loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.bill_loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  margin-top: -25px;
  margin-left: -25px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

//支付请求loading  end
</style>


<style lang="less" scoped>
@import '~@/style/common.less';


.wrap {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
}

.syj_Betinfo {
  position: relative;
  left: unset;
  top: unset;
  transform: unset;
  height: auto;
  padding-bottom: 40px;
  margin: 6% auto;

  &.edit-mode {
    .tab-content_0,
    .tab-content_1 {
      margin-top: 76px;
    }
  }

  .tab-content_0 {
    .tab-content_0_group {
      width: 400px;
      margin: 10px auto 0;
      
      .syj_betting_group {
        height: 26px;
      }
      
      .label {
        display: flex;
        align-items: center;
        > input[type="radio"]:checked ~ span:after {
          transform: unset;
          left: 2px;
          top: 2px;
          width: 6px;
          height: 6px;
        }
        > span {
          position: relative;
        }
        
        .input-wrap {
          display: flex;
          align-items: center;
          font-size: 14px;
        }
        input[type="text"] {
          position: unset;
          opacity: 1;
          width: 50px;
          height: 20px;
          margin: 0 6px 0 4px;
          border: 2px solid #fb3123;
          border-radius: 4px;
        }
        .btn {
          padding: 2px 8px;
          cursor: pointer;
          background: #e81f3c;
          color: #fff;
          border-radius: 4px;
        }
      }
    }

    .tab-content_0_num {
      max-height: 450px;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
  .tab-content_1 {
    .syj_betting_group {
      height: 26px;
    }
    
    .label {
      display: flex;
      align-items: center;
      > input[type="radio"]:checked ~ span:after {
        transform: unset;
        left: 2px;
        top: 2px;
        width: 6px;
        height: 6px;
      }
      > span {
        position: relative;
      }
      
      .input-wrap {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
      input[type="text"] {
        position: unset;
        opacity: 1;
        width: 50px;
        height: 20px;
        margin: 0 6px 0 4px;
        border: 2px solid #fb3123;
        border-radius: 4px;
      }
      .btn {
        padding: 2px 8px;
        cursor: pointer;
        background: #e81f3c;
        color: #fff;
        border-radius: 4px;
      }
    }
    
    .tab-content_0_num {
      max-height: 450px;
      overflow-y: auto;
      overflow-x: hidden;
    }
    
    .price-wrap {
      .tz_title {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        outline: none;
        text-align: center;
        height: 36px;
        color: #fff;
        margin-right: 10px;
      }
      .tz_input {
        width: 300px;
        margin-right: 0;
        text-align: left;
        color: #333;
        &::placeholder {
          color: #ccc;
        }
      }
      .btn {
        width: 60.31px;
        margin-left: 10px;
      }
      .line {
        color: transparent;
      }
    }
    
    .section-input {
      text-align: left;
      color: #333;
      &::placeholder {
        color: #ccc;
      }
    }
  }
}

input[type="number"].lottery_input {
  -moz-appearance: textfield; /* Firefox */
  -webkit-appearance: none; /* Chrome, Safari, Edge */
  appearance: none; /* 通用属性 */
}
input[type="number"].lottery_input::-webkit-inner-spin-button,
input[type="number"].lottery_input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0; /* 去掉默认的内边距 */
}
</style>
